export enum CustomerPresent {
  TransportationCoordinator = 1,
  DirectorOfTransportation = 2,
  Principal = 3,
  AssistantPrincipal = 4,
  Superintendent = 5,
  AssistantSuperBusMgr = 6,
  SpecialEd = 7,
  Other = 8,
}
